/* GUARDADOS · 27-ago-2026
 *
 * El porqué de la función está en `snippets/avora-guardados.liquid`. Aquí solo
 * las decisiones de código.
 *
 * 🔴 UN SOLO OYENTE PARA LOS 54 CORAZONES. Se escucha en `document` y se
 * resuelve con `closest('[data-guardar]')`. Enganchar uno por tarjeta obligaría
 * a volver a enganchar cada vez que el catálogo añade una página —y ese es
 * justo el paso que se olvida—. Con delegación, las tarjetas que llegan después
 * funcionan sin que nadie las toque: las del scroll infinito, las de "Vistas
 * hace poco" y las del propio panel.
 *
 * 🔴 EL ESTADO SE PINTA DESDE UNA SOLA FUNCIÓN. `sincroniza()` recorre lo que
 * haya en pantalla y lo pone al día. La misma prenda puede estar en la rejilla,
 * en "Combínalo con" y dentro del panel al mismo tiempo: quitarla en uno tiene
 * que apagar los tres corazones. Guardar el estado en cada botón habría dejado
 * tres verdades distintas.
 */
(function () {
  var LLAVE = 'avora:guardados';
  var TOPE = 60;

  var panel   = document.querySelector('[data-guarda]');
  var rejilla = panel && panel.querySelector('[data-guarda-rejilla]');
  var vacio   = panel && panel.querySelector('[data-guarda-vacio]');
  var pie     = panel && panel.querySelector('[data-guarda-pie]');
  var cuentas = [].slice.call(document.querySelectorAll('[data-guarda-cuenta]'));
  var entradas = [].slice.call(document.querySelectorAll('[data-abre-guarda]'));

  /* ── EL ALMACÉN ─────────────────────────────────────────────────────────── */
  function leer() {
    try {
      var v = JSON.parse(localStorage.getItem(LLAVE) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function escribir(lista) {
    try { localStorage.setItem(LLAVE, JSON.stringify(lista.slice(0, TOPE))); } catch (e) { /* modo privado */ }
  }

  /* 🔴 EL MODO PRIVADO DE SAFARI DEJA ESCRIBIR Y NO GUARDA. No basta con que el
     `try` no truene: hay que comprobar que lo escrito se puede volver a leer. Si
     no, la función entera no se enciende — mejor que no exista a que la clienta
     guarde cinco prendas y las pierda al cambiar de página sin saber por qué. */
  function almacenSirve() {
    try {
      var p = '__avora__';
      localStorage.setItem(p, '1');
      var ok = localStorage.getItem(p) === '1';
      localStorage.removeItem(p);
      return ok;
    } catch (e) { return false; }
  }
  if (!almacenSirve()) return;

  /* ── PINTAR EL ESTADO ───────────────────────────────────────────────────── */
  function sincroniza() {
    var lista = leer();
    var dentro = {};
    lista.forEach(function (h) { dentro[h] = true; });

    [].slice.call(document.querySelectorAll('[data-guardar]')).forEach(function (b) {
      var h = b.getAttribute('data-guardar');
      var esta = !!dentro[h];
      b.hidden = false;                                  /* nace oculto: aquí se enciende */
      b.setAttribute('aria-pressed', esta ? 'true' : 'false');
      /* El rótulo cambia con el estado. Un botón que siempre dice "Guardar" pero
         que a veces quita es el clásico interruptor que miente. */
      var nombre = b.getAttribute('aria-label') || '';
      nombre = nombre.replace(/^(Guardar|Quitar de guardados)\s+/, '');
      b.setAttribute('aria-label', (esta ? 'Quitar de guardados ' : 'Guardar ') + nombre);

      /* El botón de la ficha lleva palabra a la vista, y esa palabra también
         tiene que seguir al estado: un botón que dice "Guardar" y lo que hace es
         quitar es el interruptor que miente. Los corazones del catálogo no
         tienen texto, así que ahí esto no encuentra nada y no hace nada. */
      var t = b.querySelector('[data-guardar-t]');
      if (t) t.textContent = esta ? 'Guardada' : 'Guardar';
    });

    cuentas.forEach(function (c) {
      c.textContent = lista.length;
      /* El número se esconde en cero, como la pastilla de la bolsa. `hidden` no
         basta en este tema —un `display` de autor le gana—, así que además se
         marca con un atributo que el CSS sí respeta. */
      if (lista.length) c.removeAttribute('data-cero'); else c.setAttribute('data-cero', '');
    });
    entradas.forEach(function (e) { e.hidden = false; });

    return lista;
  }

  /* ── GUARDAR / QUITAR ───────────────────────────────────────────────────── */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-guardar]');
    if (!b) return;
    ev.preventDefault();
    ev.stopPropagation();          /* la tarjeta entera es un enlace: no navegar */

    var h = b.getAttribute('data-guardar');
    var lista = leer();
    var i = lista.indexOf(h);
    if (i >= 0) lista.splice(i, 1);
    else lista.unshift(h);         /* lo último guardado va primero */
    escribir(lista);
    sincroniza();

    /* 🔴 EL LATIDO VA AQUÍ Y NO EN `sincroniza()`, que es la trampa evidente.
       `sincroniza()` corre también al cargar la página y al llegar un cambio de
       otra pestaña: poner el latido ahí haría que TODOS los corazones ya
       guardados palpitaran solos en cada carga. Aquí solo late el que la
       clienta acaba de tocar, y solo al GUARDAR — quitar algo no merece
       celebración.
       El `void offsetWidth` es para que dos toques seguidos vuelvan a latir:
       sin él el navegador ve el mismo atributo y no reinicia la animación. */
    if (i < 0) {
      b.removeAttribute('data-late');
      void b.offsetWidth;
      b.setAttribute('data-late', '');
    }

    /* Si el panel está abierto y se acaba de quitar algo, se repinta para que la
       prenda desaparezca de ahí mismo. Quitarla y verla seguir ahí se lee como
       que el botón no sirvió. */
    if (panel && !panel.hidden) pinta();
  });

  /* ── EL PANEL ───────────────────────────────────────────────────────────── */
  if (!panel) { sincroniza(); return; }

  /* Mismo motivo que en el buscador: `.a-cima` se TRANSFORMA al bajar, y un
     ancestro transformado se vuelve el marco de referencia de cualquier
     `position: fixed` — el panel saldría recortado a la altura del header.
     Mudarlo al cuerpo lo saca de ese ancestro hoy y el día que alguien le ponga
     un `filter`. Ver `assets/avora-buscador.js`. */
  if (panel.parentNode !== document.body) document.body.appendChild(panel);

  var devolver = null;
  var altura = 0;

  function traba() {
    altura = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -altura + 'px';
    document.body.style.width = '100%';
  }
  function destraba() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, altura);
  }

  var prev = new URL(location.href).searchParams.get('preview_theme_id');
  function conVistaPrevia(u) {
    return prev ? u + '&preview_theme_id=' + encodeURIComponent(prev) : u;
  }

  var pintando = 0;
  function pinta() {
    var lista = sincroniza();
    var turno = ++pintando;   /* si se pide otra pintada, la vieja se descarta */

    if (!lista.length) {
      rejilla.innerHTML = '';
      vacio.hidden = false;
      pie.hidden = true;
      return;
    }
    vacio.hidden = true;
    pie.hidden = false;

    Promise.all(lista.map(function (h) {
      return fetch(conVistaPrevia('/products/' + h + '?view=tarjeta'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (trozos) {
      if (turno !== pintando) return;
      rejilla.innerHTML = '';
      var puestas = 0;
      trozos.forEach(function (html, i) {
        if (!html) {
          /* 🔴 UNA PRENDA BORRADA NO SE BORRA SOLA DEL ALMACÉN. Si Priscila quita
             un producto, su handle sigue guardado y `?view=tarjeta` devuelve 404.
             Se limpia aquí: es el único momento en que sabemos que ya no existe.
             Callar y dejar el hueco haría que el número del header nunca
             cuadrara con lo que se ve. */
          var l = leer(); var j = l.indexOf(lista[i]);
          if (j >= 0) { l.splice(j, 1); escribir(l); }
          return;
        }
        var d = new DOMParser().parseFromString(html, 'text/html');
        var art = d.querySelector('.p-pieza');
        if (!art) return;
        /* `data-visto` a mano: el observador del movimiento ya recorrió la página
           y es ciego a lo que llega después. Sin esto la tarjeta se queda 18px
           abajo de su sitio y traslúcida, para siempre. */
        art.setAttribute('data-visto', '');
        rejilla.appendChild(art);
        puestas++;
      });
      sincroniza();
      if (!puestas) { vacio.hidden = false; pie.hidden = true; }
    });
  }

  function abre(e) {
    if (e) e.preventDefault();
    devolver = document.activeElement;
    AvoraPanel.abre(panel);
    traba();
    pinta();
    setTimeout(function () {
      var c = panel.querySelector('[data-guarda-cerrar]');
      if (c) { try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); } }
    }, 60);
  }
  /* Mismo trato que el cajón: el foco vuelve ya, el fondo se destraba cuando el
     panel terminó de irse. Ver `avora-panel.js`. */
  function cierra() {
    AvoraPanel.cierra(panel, destraba);
    if (devolver && devolver.focus) devolver.focus();
  }

  entradas.forEach(function (a) { a.addEventListener('click', abre); });
  [].slice.call(panel.querySelectorAll('[data-guarda-cerrar]'))
    .forEach(function (b) { b.addEventListener('click', cierra); });

  /* El telón cierra: tocar fuera del panel es el gesto que todo el mundo intenta
     antes de buscar la equis. */
  panel.addEventListener('click', function (e) { if (e.target === panel) cierra(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) cierra();
  });

  /* Dos pestañas abiertas: guardar en una tiene que verse en la otra. `storage`
     solo dispara en las OTRAS pestañas, así que no hay bucle. */
  addEventListener('storage', function (e) {
    if (e.key !== LLAVE) return;
    sincroniza();
    if (!panel.hidden) pinta();
  });

  sincroniza();
})();

